module.exports = __webpack_public_path__ + "static/img/weixin_erweim2.a8f0b61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/weixin_erweim2.png
// module id = qIfO
// module chunks = 16